(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const SHOP_RETURN_STATE_KEY = 'shop-return-state';
  const SHOP_RETURN_RESTORE_KEY = 'shop-return-restore';
  const shopCollectionUrl = new URL('{{ routes.all_products_collection_url }}', window.location.origin);
  const currentUrl = new URL(window.location.href);

  let shopReturnState = null;
  try {
    const storedState = sessionStorage.getItem(SHOP_RETURN_STATE_KEY);
    shopReturnState = storedState ? JSON.parse(storedState) : null;
  } catch {}

  let pendingRestoreUrl = null;
  try {
    pendingRestoreUrl = sessionStorage.getItem(SHOP_RETURN_RESTORE_KEY);
  } catch {}
  const shouldRestoreSavedPosition =
    currentUrl.pathname === shopCollectionUrl.pathname &&
    typeof shopReturnState?.scrollY === 'number' &&
    pendingRestoreUrl === currentUrl.toString();

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (currentUrl.hash) {
        const card = document.getElementById(currentUrl.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }

      if (!shouldRestoreSavedPosition) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, shopReturnState.scrollY);
        });
      });
    },
    { once: true }
  );

  if (shouldRestoreSavedPosition) {
    window.addEventListener(
      'load',
      () => {
        window.scrollTo(0, shopReturnState.scrollY);
        sessionStorage.removeItem(SHOP_RETURN_RESTORE_KEY);
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
